import { gql } from "@apollo/client";

export const ADD_JOB = gql`
  mutation create_job($input: CreateJobInput!) {
    create_job(input: $input) {
      status
      error
      job {
        id
        title
      }
    }
  }
`;

export const UPDATE_JOB_STATUS = gql`
  mutation update_job_status($input: UpdateJobStatusInput!) {
    update_job_status(input: $input) {
      status
      error
    }
  }
`;

export const UPDATE_JOB = gql`
  mutation update_job($input: UpdateJobInput!) {
    update_job(input: $input) {
      status
      error
      job {
        id
        title
      }
    }
  }
`;

export const UPDATE_JOB_CANDIDATE_BY_JOB = gql`
  mutation upsert_job_candidate($input: UpsertJobCandidateInput!) {
    upsert_job_candidate(input: $input) {
      status
      error
    }
  }
`;

export const UPDATE_JOB_CANDIDATE = gql`
  mutation change_job_candidate_status($input: ChangeJobCandidateStatusInput!) {
    change_job_candidate_status(input: $input) {
      status
      error
    }
  }
`;

export const SCHEDULE_INTERVIEW = gql`
  mutation schedule_interview($input: InterviewCreateInput!) {
    schedule_interview(input: $input) {
      status
      error
    }
  }
`;

export const EDIT_SCHEDULED_INTERVIEW = gql`
  mutation edi_schedule_interview($input: InterviewUpdateInput!) {
    update_scheduled_interview(input: $input) {
      status
      error
    }
  }
`;

export const DELETE_JOBS = gql`
  mutation delete_job($input: DeleteJobInput!) {
    delete_job(input: $input) {
      status
      error
    }
  }
`;

export const IMPORT_JOBS = gql`
  mutation ImportJobsFromExcel($input: ImportJobsFromExcelInput!) {
    import_jobs_from_excel(input: $input) {
      success
      message
      job_id
      status
      processed_count
      errors_count
      success_count
      error_count
      errors
    }
  }
`;
